import { UIChampionship25Controller } from '../../../../../shared/scripts/ui_cc/UIChampionship25Controller.ts';
export class UIDChampionship25SceneController {
    hide() {
        this.championship25SceneContainerDiv.classList.add('hidden');
    }
    show() {
        this.championship25SceneContainerDiv.classList.remove('hidden');
        this.sidebarController.deactivateAllButtons();
    }
    constructor(sidebarController){
        this.sidebarController = sidebarController;
        new UIChampionship25Controller();
        this.championship25SceneContainerDiv = document.getElementById('scene_discord_championship25_container');
    }
}
